<div>
    <label class="input-label" for="{{inputId}}" *ngIf="label !== null">
        {{label}}
    </label>
    <div class="input-with-icon" >
        <input #input type="text" [attr.name]="inputName" [ngStyle]="inlineStyleObject" id="{{inputId}}" [readonly]="isReadOnly"
            [attr.maxlength]="maxLength" [value]="textValue">
        <div class="icon" (click)="iconClicked()" *ngIf="showIcon">
            <esp-icon [name]="iconType" title="{{iconTooltip}}"></esp-icon>
        </div>
    </div>
</div>
